// extracted by mini-css-extract-plugin
export const tags = "style-module--tags--3-InU";
export const tag = "style-module--tag--x3IBS";